import { render } from "./LinksComponent.vue?vue&type=template&id=ae39b6d0"
import script from "./LinksComponent.vue?vue&type=script&lang=js"
export * from "./LinksComponent.vue?vue&type=script&lang=js"

import "./LinksComponent.vue?vue&type=style&index=0&id=ae39b6d0&lang=css"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__